<template>
  <Popover v-if="list.length > 0" :name="name">
    <div class="vert-scroll popover__list_long">
      <p v-for="item, index in list" :key="index">
        {{ item }}
      </p>
    </div>
  </Popover>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'shifts-popover',
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style scoped>
.popover__list_long {
  padding-top: 1em;
  text-align: center;
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/ItemsPopover.vue